import React from "react";
import { withTranslation } from 'react-i18next'
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Footer from "../../../Footer/FooterBottom";
import UserForm from "./Forms/Step1";
import CardForm from "./Forms/Step2";
import Backgrounds from "../../../Admin/Question/View/Background";

class SingleRegister extends React.Component {

    state = { data: {}, next: 1 };

    componentDidMount() {
        window.scrollToPosition("single-register-section");
    }

    saveLoginInfo = data => {
        this.setState({
            data: { ...data },
            next: 2
        });
    }

    goBack = () => {
        if (this.state.next > 1) {
            this.setState({
                next: this.state.next - 1
            });
        }
    }

    goNext = () => {
        this.setState({
            next: this.state.next + 1
        });
    }


    renderForm = () => {
        if (this.state.next === 1)
            return <UserForm onSubmit={this.saveLoginInfo} goBack={this.goBack} />;
        else if (this.state.next === 2)
            return <CardForm goBack={this.goBack} />;
        else if (this.state.next === 3)
            return <CardForm goBack={this.goBack} />;
    }

    render() {
        const { t } = this.props;

        return (
            <>
                <Helmet>
                    <title>
                        {t('Pages.Register.Single.title')} | {t('alarabeyya')}
                    </title>
                </Helmet>
                <section className="pos-rel call-in-action call-overlay oh" id="single-register-section" style={{
                    backgroundColor: '#75cdff',
                    borderBottom: '1px solid #0e2c53',
                    minHeight: '100vh'
                }}>
                    <div className="position-relative padding-bottom padding-top" style={{
                        minHeight: '100vh'
                    }}>
                        <Backgrounds CustomBackground="Registration" />
                        <div className="container h-100" >
                            <div className="widget widget-category col-xl-8 mx-auto">
                                <div className="widget-header">
                                    <h5 className="title">
                                        <i className="fal fa-user-graduate "></i> {t('Pages.Register.Single.title')}
                                    </h5>

                                    <div className="position-absolute" style={{
                                        top: '20px',
                                        left: '20px'
                                    }}>
                                        <Link to="/Register" className="btn btn-dark" title={t('Pages.Register.Subscriptions')}>
                                            <i className="fal fa-arrow-right"></i> <span className="d-none d-lg-inline-block"> {t('Pages.Register.Subscriptions')} </span>
                                        </Link>
                                    </div>

                                </div>
                                <div className="widget-body">
                                    {this.renderForm()}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <div className="position-sticky">
                    <Footer />
                </div>
            </>
        );
    }
}

export default withTranslation('common')(SingleRegister);